"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var i18n_1 = __importDefault(require("../i18n"));
var CaviarOverrideTwoFactorAuthenticationStrings = {
    forSecurityIsYou: function () {
        return i18n_1["default"].t('caviar_twoFactorAuthenticationStrings_forSecurityIsYou');
    },
    tooManyAttemptsExplanation: function () {
        return i18n_1["default"].t('caviar_twoFactorAuthenticationStrings_tooManyAttemptsExplanation');
    }
};
var TwoFactorAuthenticationStrings = {
    attemptsLeft: function (attempts) {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_attemptsLeft', { attempts: attempts });
    },
    cantFinditSearchForAnEmail: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_cantFinditSearchForAnEmail');
    },
    couldntSendCode: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_couldntSendCode');
    },
    enterCode: function () { return i18n_1["default"].t('twoFactorAuthenticationStrings_enterCode'); },
    forSecurityIsYou: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_forSecurityIsYou');
    },
    getHelp: function () { return i18n_1["default"].t('twoFactorAuthenticationStrings_getHelp'); },
    invalidOrIncorrectCode: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_invalidOrIncorrectCode');
    },
    resendCode: function () { return i18n_1["default"].t('twoFactorAuthenticationStrings_resendCode'); },
    sendToEmail: function () { return i18n_1["default"].t('twoFactorAuthenticationStrings_sendToEmail'); },
    sendToMobile: function () { return i18n_1["default"].t('twoFactorAuthenticationStrings_sendToMobile'); },
    somethingWentWrong: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_somethingWentWrong');
    },
    submit: function () { return i18n_1["default"].t('twoFactorAuthenticationStrings_submit'); },
    tooManyAttemptsExplanation: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_tooManyAttemptsExplanation');
    },
    tryAgain: function () { return i18n_1["default"].t('twoFactorAuthenticationStrings_tryAgain'); },
    twoStepVerification: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_twoStepVerification');
    },
    unexpectedErrorTryAgain: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_unexpectedErrorTryAgain');
    },
    weSentACodeTo: function (contactAddress) {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_weSentACodeTo', { contactAddress: contactAddress });
    },
    weTriedToSendYouCode: function () {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_weTriedToSendYouCode');
    },
    wrongCodeNumTriesRemaining: function (num) {
        return i18n_1["default"].t('twoFactorAuthenticationStrings_wrongCodeNumTriesRemaining', {
            num: num
        });
    },
    caviar: CaviarOverrideTwoFactorAuthenticationStrings
};
exports["default"] = TwoFactorAuthenticationStrings;
